import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Team from "./pages/Team";
import Contact from "./pages/Contact";
import Manufacturing from "./pages/Manufacturing";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Login from "./pages/Login";
import AdminBlog from "./pages/AdminBlog";
import AdminInquiries from "./pages/AdminInquiries";
import { Toaster } from "./components/ui/toaster";
import ScrollToTop from "./components/ScrollToTop";
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            {/* <Route path="/team" element={<Team />} /> */}
            <Route path="/contact" element={<Contact />} />
            <Route path="/:productSlug" element={<ProductDetail />} />
            <Route path="/production" element={<Manufacturing />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin/blog" element={<AdminBlog />} />
            <Route path="/admin/inquiries" element={<AdminInquiries />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
